export default __webpack_public_path__ + "static/media/Relaxing_bath.d6619543.webp";